<div class="card justify-content-center">
  @if (resourceDef && config) {
    <dhs-form [action]="'ADD'" [formtype]="'popup'" [config]="config" [fieldGroup]="resourceDef.form" (saveFinished)="onSaveFinished($event)" [data]="data_.info">
    </dhs-form>
  }
</div>